// Set environment class before any other imports
import "@src/app/theme/environment";

import "primeflex/primeflex.css";
import "primeicons/primeicons.css";
import "primereact/resources/primereact.min.css";
import "@src/domains/shared/styles/custom.css";
import "@src/domains/shared/styles/quick-aps-bootstrap.css";
import "@src/domains/shared/styles/quick-aps-primereact.css";
import "@src/app/theme/styles/globals.css";
import "primereact/resources/themes/lara-light-blue/theme.css";

import App from "@src/app/App";
import { checkAppVersion } from "@src/app/versionCheck/versionCheck";
import { VersionUpdateNotice } from "@src/app/versionCheck/VersionUpdateNotice";
import { germanLocale } from "@src/domains/shared/helpers/dateHelper";
import { useAppStore } from "@src/domains/shared/stores/appStore";
import { addLocale, PrimeReactProvider } from "primereact/api";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { GlobalErrorBoundary } from "./providers";

async function bootstrap() {
  const isUpToDate = await checkAppVersion();

  if (!isUpToDate) {
    createRoot(document.getElementById("root")!).render(
      <StrictMode>
        <VersionUpdateNotice />
      </StrictMode>,
    );
    return;
  }

  addLocale("de", germanLocale);
  document.title = useAppStore.getState().appName();

  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <GlobalErrorBoundary>
        <BrowserRouter>
          <PrimeReactProvider value={{ locale: "de" }}>
            <App />
          </PrimeReactProvider>
        </BrowserRouter>
      </GlobalErrorBoundary>
    </StrictMode>,
  );
}

void bootstrap();
